import api from './api';
import { ReleaseNotesResponse } from '@radevents/shared';

const releaseNotesService = {
  /** Neuerungen, gruppiert nach Veroeffentlichung. Admins sehen zusaetzlich die technischen. */
  list: async (): Promise<ReleaseNotesResponse> => {
    const response = await api.get('/release-notes');
    return response.data;
  },

  /** Nur die Zahl fuer die Badge in der Navigation — laedt nicht den ganzen Feed. */
  unreadCount: async (): Promise<number> => {
    const response = await api.get('/release-notes/unread-count');
    return (response.data as { count: number }).count;
  },

  /** Alles bis jetzt als gesehen markieren — laesst die Badge in der Navigation verschwinden. */
  markRead: async (): Promise<void> => {
    await api.post('/release-notes/mark-read');
  },
};

export default releaseNotesService;
